(function(){
var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function initSpotlight(root){
  if(root.dataset.ttReady)return;root.dataset.ttReady='1';
  var main=root.querySelector('[data-tt-main]'),count=root.querySelector('[data-tt-count]');
  var pickers=Array.prototype.slice.call(root.querySelectorAll('[data-tt-pick]'));
  if(!main||!pickers.length)return;
  var index=0,timer=null,userPicked=false;
  function show(i){
    var p=pickers[i];if(!p)return;index=i;
    pickers.forEach(function(el,n){el.setAttribute('aria-pressed',n===i?'true':'false');});
    main.style.opacity='0.25';
    var img=new Image();
    img.onload=img.onerror=function(){main.srcset=p.dataset.srcset||'';main.src=p.dataset.src;main.alt=p.dataset.alt||main.alt;main.style.opacity='1';};
    img.src=p.dataset.src;
    if(count)count.textContent=(i+1)+' of '+pickers.length;
  }
  pickers.forEach(function(el,n){el.addEventListener('click',function(){userPicked=true;if(timer){clearInterval(timer);timer=null;}show(n);});});
  if(root.hasAttribute('data-tt-autoplay')&&!reduce&&pickers.length>1&&'IntersectionObserver' in window){
    new IntersectionObserver(function(entries){entries.forEach(function(e){
      if(e.isIntersecting&&!userPicked&&!timer){timer=setInterval(function(){show((index+1)%pickers.length);},3200);}
      else if(!e.isIntersecting&&timer){clearInterval(timer);timer=null;}
    });},{threshold:0.4}).observe(root);
  }
}
function initSticky(bar){
  if(bar.dataset.ttReady)return;bar.dataset.ttReady='1';
  var mode=bar.dataset.mode;
  var form=document.querySelector('product-form form[action*="/cart/add"]');
  var submit=form?form.querySelector('[type="submit"]'):null;
  var btn=bar.querySelector('[data-tt-sticky-btn]');
  if(!submit||!btn||!('IntersectionObserver' in window)){bar.remove();return;}
  new IntersectionObserver(function(entries){entries.forEach(function(e){
    var past=!e.isIntersecting&&e.boundingClientRect.top<0;
    bar.classList.toggle('is-visible',past);bar.setAttribute('aria-hidden',past?'false':'true');btn.tabIndex=past?0:-1;
  });}).observe(submit);
  btn.addEventListener('click',function(){
    if(mode==='add'&&!submit.disabled){submit.click();return;}
    var target=document.querySelector('variant-selects, variant-radios, .product-form__input')||form;
    target.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'});
    var first=target.querySelector('input:checked, input, select');
    if(first)setTimeout(function(){first.focus({preventScroll:true});},400);
  });
  var priceEl=bar.querySelector('[data-tt-sticky-price]');
  if(priceEl&&window.subscribe&&window.PUB_SUB_EVENTS){
    window.subscribe(PUB_SUB_EVENTS.variantChange,function(evt){
      try{var v=evt.data.variant;if(!v)return;
        priceEl.textContent=bar.dataset.moneyPrefix+(v.price/100).toLocaleString('en-IN');
        if(mode==='add')btn.disabled=!v.available;}catch(err){}
    });
  }
}
function boot(scope){
  (scope||document).querySelectorAll('[data-tt-spotlight]').forEach(initSpotlight);
  (scope||document).querySelectorAll('[data-tt-sticky]').forEach(initSticky);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot();});else boot();
document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();
